module.exports = __webpack_public_path__ + "media/src/img/payment/yandex-logo-3e6dade1067a7085e984e955e5a3e078.svg";